module.exports = __webpack_public_path__ + "media/images/consumer/pages/recipes/ThanksgivingLTO/GreenBeanCasserole-819cc50f5388ac4dc29ca73c1d8645ab.jpg";